/**
 * Resign: the store side of the tile.
 *
 * `showAbort` is here because the tile is HIDDEN, not merely disabled, while the
 * abort window is open (P1-2). The old screen mounts Resign on `!showAbort &&
 * playing` (`BottomControlsComponent` L143) and the app lane hides it the same
 * way (`BottomControls/View.tsx` L249-269): before the first move the legal
 * action is Abort, and a live Resign tile one pixel away from it is how a rated
 * game gets thrown away by a mis-tap.
 */
import {useLiveGame} from '@/Store/liveGameStore';
import {selectGameOver, selectShowAbort} from '@/Store/liveGame/selectors';

export type ResignTileModel = {
  gameOver: boolean;
  /** the pre-first-move window is open -> the tile is not mounted at all */
  showAbort: boolean;
  /** the store action — a stable identity, so the View's dialog keeps its deps */
  resign: () => void;
};

export function useResignTileModel(): ResignTileModel {
  return {
    gameOver: useLiveGame(selectGameOver),
    showAbort: useLiveGame(selectShowAbort),
    resign: useLiveGame(s => s.actions.resign),
  };
}
